import { useIsDesktop } from "common/MediaQueries"
import { Dispatch, SetStateAction } from "react"
import styled from "styled-components"
import {
  StyledBody,
  StyledHeaderH2,
  StyledHeaderSubtitle,
  StyledLink,
} from "./BodyText"

const StyledWrapper = styled.div`
  display: flex;
  margin-top: 40px;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  ${(p) => p.theme.breakpoints.down("sm")} {
    flex-direction: column;
    margin-top: 20px;
  }
`

const StyledPopUpLink = styled.div`
  text-decoration: underline;
  color: ${(p) => p.theme.colors.saphire};
  cursor: pointer;
`

const StyledIconText = styled.div<{ $margin?: boolean }>`
  width: 33%;
  ${(p) => p.$margin && "margin-top: 70px"};
  ${(p) => p.theme.breakpoints.down("sm")} {
    flex-direction: row;
    display: flex;
    width: 100%;
    align-items: center;
    margin-top: 0px;
    justify-content: flex-start;
    svg {
      margin-top: 10px;
    }
  }
`

const StyledTextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  ${(p) => p.theme.breakpoints.down("sm")} {
    margin-right: 30px;
    align-items: flex-start;
  }
  p {
    max-width: 200px;
    ${(p) => p.theme.breakpoints.down("sm")} {
      max-width: 240px;
    }
  }
`
const StyledLine = styled.div`
  border: 0.5px solid #999999;
  width: 100%;
  margin-top: 20px;
  margin-bottom: 20px;
`

type IconTextBodyProps = {
  title: string
  data: Array<any>
  setModalOpen?: Dispatch<SetStateAction<boolean>>
  setModalType?: Dispatch<SetStateAction<string>>
}

const IconTextBody = ({
  data,
  title,
  setModalOpen,
  setModalType,
}: IconTextBodyProps) => {
  const isDesktop = useIsDesktop()
  return (
    <>
      <StyledHeaderH2 $margin={40}>{title}</StyledHeaderH2>
      <StyledWrapper>
        {data.map((item) => {
          return (
            <>
              <StyledIconText $margin={item?.margin}>
                {item.icon}
                <StyledTextWrapper>
                  <StyledHeaderSubtitle>{item.text}</StyledHeaderSubtitle>
                  <StyledBody $margin={!isDesktop && 1}>
                    {item.subText}
                  </StyledBody>
                  {item?.link && (
                    <StyledLink $color="#4C607E" href="/services-centers">
                      {item.link}
                    </StyledLink>
                  )}
                  {item?.popUp && (
                    <StyledPopUpLink
                      onClick={() => {
                        setModalOpen(true)
                        setModalType(item?.type)
                      }}
                    >
                      {item.popUp}
                    </StyledPopUpLink>
                  )}
                </StyledTextWrapper>
              </StyledIconText>
              {!isDesktop && <StyledLine />}
            </>
          )
        })}
      </StyledWrapper>
    </>
  )
}

export default IconTextBody
